import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import moment from 'moment';
import {
    Grid,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Card,
    CardContent,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import { fetchAccountInvoices } from 'Console/data/accounts/actions';
import { selectAccountInvoices } from 'Console/data/accounts/selectors';
import { MOMENT_DATE_FORMAT_DISPLAY } from 'Console/constants/date';

const styles = (theme) => ({
    root: {
        flexGrow: 1,
        alignItems: 'center',
        padding: '0 24px',
    },
    title: {
        display: 'inline-block',
        fontWeight: 'bold',
        paddingBottom: theme.typography.pxToRem(28),
    },
});

class Invoices extends Component {
    componentDidMount() {
        const { fetchAccountInvoices } = this.props;
        fetchAccountInvoices();
    }

    render() {
        const { classes, intl, invoices } = this.props;
        return (
            <Grid container className={classes.root}>
                <Grid item xs={12}>
                    <Typography variant="subtitle1" className={classes.title}>
                        {intl.formatMessage({ id: 'Accounts.settings.invoices' })}
                    </Typography>
                </Grid>

                <Grid item xs={12}>
                    <Card className={classes.card}>
                        <CardContent>
                            <Table className={classes.table}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>
                                            {intl.formatMessage({
                                                id: 'Accounts.settings.invoices.number',
                                            })}
                                        </TableCell>

                                        <TableCell align="right">
                                            {intl.formatMessage({
                                                id: 'Accounts.settings.invoices.billingDate',
                                            })}
                                        </TableCell>
                                        <TableCell align="right">
                                            {intl.formatMessage({
                                                id: 'Accounts.settings.invoices.amount',
                                            })}
                                        </TableCell>
                                        <TableCell align="right">
                                            {intl.formatMessage({
                                                id: 'Accounts.settings.invoices.status',
                                            })}
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {invoices.map((row) => (
                                        <TableRow key={row.id}>
                                            <TableCell component="th" scope="row">
                                                {row.numberInvoices}
                                            </TableCell>
                                            <TableCell align="right">
                                                {moment(row.billingDate, 'x').format(
                                                    MOMENT_DATE_FORMAT_DISPLAY
                                                )}
                                            </TableCell>
                                            <TableCell align="right">{row.amount}</TableCell>
                                            <TableCell align="right">{row.status}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        );
    }
}

export default connect(
    (state) => ({
        invoices: selectAccountInvoices(state),
    }),
    {
        fetchAccountInvoices,
    }
)(withStyles(styles)(injectIntl(Invoices)));
